module.exports = __webpack_public_path__ + "img/location.5f2fd3ba.svg";